const INFO = {
  main: {
    title: 'Portfolio',
    name: 'Skabeo',
    email: 'spencerokyere95@gmail.com',
    logo: '../assets/logo.jpeg',
  },

  socials: {
    twitter: 'https://twitter.com/black_okyere',
    github: 'https://github.com/skabeo',
    linkedin: 'https://www.linkedin.com/in/spencer-okyere/',
    angellist: 'https://wellfound.com/u/okyere-spencer',
  },

  homepage: {
    title: 'Full-stack web and mobile app developer',
    description: 'I am a highly talented and experienced full stack developer with expertise in a variety of technologies such as Node.js, React, Redux, Ruby, Ruby on Rails, and NoSQL. I have successfully produced multiple projects using my strong knowledge of these tools, demonstrating my ability to manage end-to-end development chores flawlessly. My knowledge of Node.js enables me to design scalable and efficient server-side applications, whilst my knowledge of React and Redux enables me to create dynamic and interactive user interfaces. Furthermore, my command of Ruby and Ruby on Rails allows me to easily construct powerful and maintainable online apps.',
  },

  about: {
    title: 'I’m Spencer Okyere. I live in Accra, Ghana',
    description: 'Throughout my professional journey, I have undertaken a diverse array of projects, honing my skills and expertise in the field. Notably, I have had the privilege of studying at Microverse, a renowned online full stack school, where I further expanded my knowledge and refined my abilities. The rigorous curriculum at Microverse exposed me to a wide range of real-world projects, providing invaluable hands-on experience and fostering a deep understanding of industry best practices. Through this immersive learning environment, I gained the necessary foundations to excel in the world of full stack development.',
  },

  articles: {
    title: 'Exploring the Creative Journey: Insights and Inspiration from My Artistic Adventures.',
    description: 'Dive into my article page, where I share captivating insights and inspiration derived from my artistic adventures, offering a glimpse into the creative process, personal reflections, and thought-provoking observations that fuel my artistic endeavors, aiming to ignite your imagination and spark meaningful conversations within the art community and beyond',
  },

  projects: [
    {
      title: "Space Travelers' Hub",
      description: "The Space Travelers' Hub is a webapp that fetches data from the rockets endpoint API from space X and also from the mission endpoint API. The Space Travelers' Hub is a web application that allows users to explore and reserve space missions and rockets.",
      logo: 'https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png',
      linkText: 'View Project',
      link: 'https://github.com/skabeo/my-space-hub',
    },

    {
      title: 'Bookstore',
      description: 'Bookstore is a simple webapp application that uses redux state management to manage the state of the application with react. Bookapp allows users to add a book to an API and in turn update the state of the book in redux and in turn displaying it in the UI.',
      logo: 'https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png',
      linkText: 'View Project',
      link: 'https://github.com/skabeo/bookstore',
    },

    {
      title: 'Math Magicians',
      description: 'Math magicians is a website for all fans of mathematics. It is a Single Page App (SPA) that allows users to make simple calculations and Read a random math-related quote.',
      logo: 'https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png',
      linkText: 'View Project',
      link: 'https://github.com/skabeo/Math-Magician',
    },

    {
      title: 'The Saspen Kitchen',
      description: 'A simple restaurant project which showcases different meals. It has the capability to like any food you like and to click and see the details of each meal and comment on it.',
      logo: 'https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png',
      linkText: 'View Project',
      link: 'https://github.com/skabeo/The-Saspen-Kitchen',
    },

    {
      title: 'Leaderboard',
      description: 'Leaderboard is a simple webpage that allows users to add their name plus a score and displays the data input by the user. Leaderboard sends a POST request to the leaderboard API when a user enters a data and the retrieves the data with a GET request to display the data.',
      logo: 'https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png',
      linkText: 'View Project',
      link: 'https://github.com/skabeo/Leaderboard',
    },

    {
      title: 'Afrochella',
      description: 'Afrochella is a vibrant and dynamic web page dedicated to celebrating African culture and music. It features stunning visuals, informative content, and an engaging user experience that immerses visitors in the spirit of the festival.',
      logo: 'https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png',
      linkText: 'View Project',
      link: 'https://github.com/skabeo/Afrochella-Project',
    },
  ],
};

export default INFO;
